export default __webpack_public_path__ + "static/media/full-logo-black.9cd65d6e.svg";